import React from 'react';

function Translate({ size, fill = 'currentColor', ...otherProps }) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...otherProps}
    >
      <path
        d="M9.5597 3.45698H15.1676C15.527 3.45698 15.8182 3.76206 15.8182 4.13848C15.8182 4.51491 15.5269 4.82008 15.1676 4.82008H13.5897C13.3946 5.55757 12.9533 6.97011 12.0896 8.65047C11.5559 9.68886 10.8058 10.9257 9.78308 12.187C10.7726 13.261 10.917 13.7574 12.3636 14.6667L11.7879 15.873C10.2633 14.9147 9.95623 14.3275 8.90571 13.1975C7.86689 14.3157 6.60236 15.4166 5.07142 16.3789C4.96663 16.4448 4.85117 16.4762 4.73726 16.4762C4.51623 16.4762 4.30075 16.3582 4.17878 16.1452C3.99383 15.8224 4.09376 15.4037 4.40189 15.2101C5.846 14.3023 7.04174 13.2617 8.0292 12.1885C6.644 10.4783 5.71518 8.74962 5.10612 7.32835C4.95899 6.98492 5.10543 6.5816 5.43325 6.42737C5.76125 6.27324 6.14606 6.42674 6.29327 6.77008C6.84465 8.05666 7.67709 9.61325 8.90597 11.1616C10.9182 8.62375 11.857 6.08103 12.2316 4.82017H2.65061C2.2913 4.82017 2 4.515 2 4.13858C2 3.76215 2.2913 3.45698 2.65061 3.45698H8.25848V2.6816C8.25848 2.30517 8.54978 2 8.90909 2C9.2684 2 9.5597 2.30517 9.5597 2.6816V3.45698Z"
        fill={fill}
      />
      <path
        d="M17.7919 10.1379C17.6625 9.8227 17.3593 9.61914 17.0192 9.61914C17.019 9.61914 17.0187 9.61914 17.0184 9.61914C16.678 9.61945 16.3748 9.82364 16.246 10.1394C16.2442 10.1437 16.2425 10.1481 16.2408 10.1525L12.0382 21.2095C11.9239 21.5104 12.0745 21.8472 12.3748 21.9618C12.443 21.9878 12.5129 22.0001 12.5817 22.0001C12.8161 22.0001 13.0371 21.8571 13.1255 21.6244L14.0294 19.2461H19.9787L20.8738 21.6228C20.9873 21.924 21.3228 22.0761 21.6235 21.9624C21.924 21.8487 22.0758 21.5124 21.9624 21.2112L17.7981 10.1537C17.7961 10.1485 17.794 10.1432 17.7919 10.1379V10.1379ZM14.4726 18.0804L17.0178 11.3839L19.5397 18.0804H14.4726Z"
        fill={fill}
      />
    </svg>
  );
}

export default Translate;
